<template>
  <div
    class="subscription-container subscription-container-variables"
    role="list"
    :class="{ draft: subscriptionData.draft, selected: subscriptionData.checked }"
  >
    <subscription
      ref="subscriptionRef"
      v-button
      :subscription="subscriptionData"
      :is-bundle-open="isBundleShown"
      :can-show-folder-badge="canShowFolderBadge"
      :is-mobile="isMobile"
      type="button"
      class="thread"
      role="listitem"
      @click.native="onSubscriptionClicked"
    />
    <transition name="toggle">
      <bundled-subscriptions
        v-if="isBundleMounted"
        v-show="isBundleShown"
        :subscription-data="subscriptionData"
        :draggable="draggable"
        @draggingChange="emitDraggingChange"
      />
    </transition>
  </div>
</template>

<script>
import Subscription from './Subscription';
import BundledSubscriptions from './BundledSubscriptions';
import { mapGetters } from 'vuex';
import { types } from '../../store/types/types';
import { subscriptionTypes } from '../../../shared/enums/subscriptionTypes';
import Button from '../../../shared/directives/button';
import { deselectAllManagers } from '../../../shared/composables/sortableRegistry';
import { useUserProfileStore } from '../../../shared/stores';

export default {
  directives: {
    Button,
  },
  props: {
    subscriptionData: {
      type: Object,
      required: true,
    },
    draggable: { type: Boolean, default: false },
    canShowFolderBadge: { type: Boolean, default: false },
    isMobile: { type: Boolean, default: false },
  },
  emits: ['draggingChange'],
  data: function () {
    return {
      isBundleMounted: false,
      isBundleShown: false,
    };
  },
  computed: {
    ...mapGetters({
      otp: types.MESSAGES_GET_OTP_INBOXES,
      threadBundles: types.MESSAGES_GET_THREAD_BUNDLES,
      chosenFolderAndMailOwner: types.MESSAGES_GET_CHOSEN_FOLDER_AND_MAIL_OWNER,
    }),
    userProfileStore() {
      return useUserProfileStore();
    },
    profile() {
      return this.userProfileStore.institutionProfile;
    },
  },
  methods: {
    onSubscriptionClicked() {
      if (this.subscriptionData.subscriptionType === subscriptionTypes.BUNDLE) {
        this.isBundleMounted = true;
        this.isBundleShown = !this.isBundleShown;
        deselectAllManagers(); // Override auto select on click from MultiDrag of SortableJS
      }
    },
    deleteBtnClicked() {
      this.$refs.subscriptionRef.deleteBtnClicked();
    },
    emitDraggingChange(isDragging) {
      this.$emit('draggingChange', isDragging);
    },
  },
  components: { BundledSubscriptions, Subscription },
};
</script>

<style scoped lang="scss">
@use '../../../shared/assets/scss/core/animations' as *;
.subscription-container-variables {
  --thread-item-gap: 2px;
}
.subscription-container {
  margin-top: var(--thread-item-gap);
}
</style>
